/** Mirrors PostgreSQL `iam.principal_type` and `@act/server/db` `PrincipalType`. */
export enum PrincipalType {
  USER = 'user',
  GROUP = 'group',
  SERVICE_ACCOUNT = 'service_account',
}
